import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Find from "./pages/Find";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Submit from "./partials/Submit";
import Practitioners from "./pages/Practitioners";
import ProfilePage from './pages/ProfilePage';
import Events from "./pages/Events";
import SubmitProvider from "./partials/SubmitProvider"
import { useAuth } from "./contexts/AuthContext";
import SingleEvent from "./pages/SingleEvent";
import SinglePractitioner from "./pages/SinglePractitioner";
import SubmitBlog from './pages/SubmitBlog';



const AppRoutes: React.FC = () => {
    const { currentUser } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/find" element={<Find />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/view" element={<SingleEvent />} /> 
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<Blog />} />
      <Route path="/about" element={<About />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/practitioners" element={<Practitioners />} />
      <Route path="/practitioners/view" element={<SinglePractitioner />} />
      <Route path="/auth" element={<ProfilePage />} />
      <Route path="/login" element={<ProfilePage />} />
      <Route path="/profile" element={<ProfilePage />} />
      {currentUser ? <Route path="/submit_provider" element={<SubmitProvider />} /> : null}
      {currentUser && (
        <>
          <Route path="/blog/submit" element={<SubmitBlog />} />
          <Route path="/blog/submit/:id" element={<SubmitBlog />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes; 